import { useEffect } from "react";

export default function useSEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} | Ideal Entertainment`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
      let og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute("content", description);
    }
    let ogt = document.querySelector('meta[property="og:title"]');
    if (ogt && title) ogt.setAttribute("content", `${title} | Ideal Entertainment`);
  }, [title, description]);
}
